import * as React from "react";

const columns = (t) => [
    {
        field: "name",
        label: t ? t("common.name") : "Nazwa",
        sort: "desc",
        width: 53,
    }
];

export default columns;